/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Project_Import_Status_DoneInputs */

const en_team_project_import_status_done = /** @type {(inputs: Team_Project_Import_Status_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Done`)
};

const fr_team_project_import_status_done = /** @type {(inputs: Team_Project_Import_Status_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminé`)
};

const de_team_project_import_status_done = /** @type {(inputs: Team_Project_Import_Status_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erledigt`)
};

const it_team_project_import_status_done = /** @type {(inputs: Team_Project_Import_Status_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fatto`)
};

const ru_team_project_import_status_done = /** @type {(inputs: Team_Project_Import_Status_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сделанный`)
};

const es_team_project_import_status_done = /** @type {(inputs: Team_Project_Import_Status_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hecho`)
};

const zh_cn2_team_project_import_status_done = /** @type {(inputs: Team_Project_Import_Status_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完毕`)
};

const ja_team_project_import_status_done = /** @type {(inputs: Team_Project_Import_Status_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`終わり`)
};

const hi_team_project_import_status_done = /** @type {(inputs: Team_Project_Import_Status_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हो गया`)
};

const pt_pt2_team_project_import_status_done = /** @type {(inputs: Team_Project_Import_Status_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feito`)
};

/**
* | output |
* | --- |
* | "Done" |
*
* @param {Team_Project_Import_Status_DoneInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_project_import_status_done = /** @type {((inputs?: Team_Project_Import_Status_DoneInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Project_Import_Status_DoneInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_project_import_status_done(inputs)
	if (locale === "de") return de_team_project_import_status_done(inputs)
	if (locale === "it") return it_team_project_import_status_done(inputs)
	if (locale === "ru") return ru_team_project_import_status_done(inputs)
	if (locale === "es") return es_team_project_import_status_done(inputs)
	if (locale === "zh-CN") return zh_cn2_team_project_import_status_done(inputs)
	if (locale === "ja") return ja_team_project_import_status_done(inputs)
	if (locale === "hi") return hi_team_project_import_status_done(inputs)
	if (locale === "pt-PT") return pt_pt2_team_project_import_status_done(inputs)
	return en_team_project_import_status_done(inputs)
});